module.exports = __webpack_public_path__ + "assets/img/clip-icon.97c71f00.png";